module.exports = __webpack_public_path__ + "img/terms-icon.296ca4fd.svg";